<template>
  <div class="totalMessage" v-show="show" @touchmove.prevent>
    <span>{{text}}</span>
  </div>
</template>
<script>
export default {
  name: 'totalMessage',
  data(){
      return{
        show:false,
        text:''
      }
  },
  methods:{
    // open(){
    //   this.show = true
    // },
    // close(){
    //   this.show = false
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .totalMessage{
        position: fixed;
        z-index: 101;
        bottom: 20%;
        left: 0;
        right: 0;
        margin: auto;
        text-align: center;
        span{
          color: #fff;
          font-size: 0.6rem;
          padding: 0.2rem 0.3rem;
          background: rgba(0,0,0,0.7);
          opacity: 0.9;
          border-radius: 0.1rem;
          transition: all 0.5s;
        }
    }
</style>